<template>
    <div>
        <h3>記事の使い方</h3>
        <div>
            <p>
                記事は様々なことに使えます。
                貸し本棚サイドから、記事の使い方について限定することはしません。
                利用規約に反しない限り、どのような使い方でも可能です。
            </p>
            <p>
                記事を書くことにより、作品のみを公開している投稿サービスでは得られない追加情報を読者に提供することができます。
            </p>
            <p class="font-weight-bold">
                特定・不特定の他者を貶めるような攻撃的な記事は推奨しません。
                ご自身の本棚を汚すことになります。
            </p>

            <h4>作品資料として</h4>
            <p>
                最も一般的として考えられる使い方は「作品資料」です。
            </p>
            <p>
                登場人物も多く、壮大なテーマを取り扱った作品、あるいはシリーズ作品においては、
                本編以外の情報も充実していることが望ましいでしょう。
            </p>
            <p>
                登場人物の紹介と設定、その年表、イラスト、裏設定などをまとめておくと、
                本編では不明だった部分が審らかになるかもしれません。
            </p>
            <p>
                作品の舞台設定、歴史、文化、独自要素についての記載もあると更に充実します。
                読者によっては、これらの情報から逆引きで作品を読み始めるきっかけになることがあります。
                小説作品では難しいプロモーションを意識した記事作りができます。
            </p>

            <h4>創作論や書評、自己レビュー</h4>
            <p>
                小説執筆についての考え方や気付き、常々感じていることなどを不定期なツイートではなく、
                構造化された文書でまとめておくことで、自分自身の作家性と向き合うことができます。
                記事には誰かがコメントすることはありません。
                誰かが読むことがあるかもしれませんが、基本的には書いたものと自分自身に向き合うことになります。
            </p>
            <p>
                誰かの作品について書評をまとめることもできます。
                ご自身が書かれている作品と同ジャンルの小説についての書評は
                「辛口」を謳って弱みを見せない無責任なレビューと違って読む価値のあるものです。
            </p>
            <p>
                自己紹介やこれまでの執筆経歴などについてもまとめることができます。
                レイアウトが自由なので、画像やテーブルを使ってわかりやすく詳細に渡った履歴が作成できます。
            </p>

            <h4>作品ごとの活動記録</h4>
            <p>
                活動記録をつけることもできますが、
                ブログや日記のように大量に投稿する形での利用には向きません。
                小説作品に関連性のない記事を公開しても、本棚を充実させることはできません。
                ジャンル公開の記事は６作品ずつしか表示されず、
                記事一覧などもないので、過去記事は埋もれていきます。
                日々のレポートを行うのであれば、一言欄の方が便利です。
            </p>
            <p>
                シーズンごと、あるいは作品単位での活動記録、
                取材記事、取材と称した旅行記などであれば、作品と関連付けられます。
            </p>

        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "記事の使い方 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>